import styled from 'styled-components';

export const PaginationCustomStyled = styled.div`
  /*===============================================
 Container 
===============================================*/

  /*===============================================
Theme 
===============================================*/
  .theme_standard_pagination {
    .pagination {
      display: flex;
      width: 100%;
      list-style: none;
      justify-content: flex-end;
      align-items: center;
      margin: 0;
      padding: 0;
      .previous {
        display: flex;
      }
      .next {
        display: flex;
      }
      li {
        cursor: pointer;
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
        color: ${({ theme }) => theme.COLORS.BLACK_2};
        transition: all 0.3s ease;
        border-radius: 50%;
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        
        &:hover {
          background: ${({ theme }) => theme.COLORS.PURPLE_3};
          color: ${({ theme }) => theme.COLORS.PURPLE_1};
          box-shadow: 0 4px 8px rgba(75, 30, 120, 0.2);
        }
        
        a {
          padding: 0;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          text-decoration: none;
          color: inherit;
          transition: all 0.3s ease;
        }
      }
      .active {
        background: ${({ theme }) => theme.COLORS.PURPLE_1};
        color: ${({ theme }) => theme.COLORS.WHITE_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
        border-radius: 50%;
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        transform: scale(1.1);
        &:hover {

        }
      }
    }
    .pagination li.disabled {
      cursor: not-allowed;
      opacity: 0.5;
      
      a {
        display: none;
      }
      
      &:hover {
        background: transparent !important;
        color: ${({ theme }) => theme.COLORS.BLACK_2} !important;
        transform: none !important;
        box-shadow: none !important;
      }
    }
  }
`;
